import React from "react";

const AuthXLogo = ({ variant = "dark", size = "md" }) => {
  const sizes = {
    sm: { mark: 26, font: "1rem", gap: 8 },
    md: { mark: 32, font: "1.18rem", gap: 10 },
    lg: { mark: 40, font: "1.42rem", gap: 12 },
  };
  const dims = sizes[size] || sizes.md;
  const isLight = variant === "light";

  return (
    <div
      className={`ax-brand ax-brand-${variant}`}
      style={{ display: "inline-flex", alignItems: "center", gap: dims.gap }}
    >
      <span
        className="ax-brand-mark"
        style={{
          width: dims.mark,
          height: dims.mark,
          borderRadius: 8,
          display: "inline-grid",
          placeItems: "center",
          background: isLight
            ? "rgba(255,255,255,0.14)"
            : "linear-gradient(135deg, #418bff 0%, #2d7aef 100%)",
          boxShadow: isLight
            ? "inset 0 0 0 1px rgba(255,255,255,0.22)"
            : "0 6px 16px rgba(65, 139, 255, 0.28)",
        }}
      >
        <svg
          width={dims.mark * 0.58}
          height={dims.mark * 0.58}
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12 2.4 4 5.6v6.1c0 4.8 3.4 8.9 8 9.9 4.6-1 8-5.1 8-9.9V5.6L12 2.4Z"
            fill={isLight ? "#fff" : "#fff"}
            opacity={isLight ? 0.95 : 1}
          />
          <path
            d="m9 12.2 2.2 2.2L15.4 10"
            stroke={isLight ? "#418bff" : "#2d7aef"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span
        className="ax-brand-text"
        style={{
          fontFamily: 'var(--ax-font-heading)',
          fontSize: dims.font,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          color: isLight ? "#fff" : "var(--ax-ink)",
          lineHeight: 1,
        }}
      >
        Auth<span style={{ color: isLight ? "#fff" : "var(--ax-blue)" }}>X</span>
      </span>
    </div>
  );
};

export default AuthXLogo;
